import { type ComputedRef, type Ref, computed } from 'vue'

import type { MonetaryAmount } from '@backmarket/http-api/src/api-models/MonetaryAmount'

import type {
  BuyBackQuoteListing,
  BuyBackQuotePricingEstimation,
} from '~/api/buyback/offer/types'

export function usePriceToWinBackbox(
  pricingEstimation: Ref<BuyBackQuotePricingEstimation | undefined>,
  listing: Ref<BuyBackQuoteListing>,
  currency: Ref<string>,
): ComputedRef<MonetaryAmount> {
  return computed(() => {
    if (pricingEstimation.value) {
      return pricingEstimation.value.priceToWinBackbox
    }

    if (listing.value.priceToWinBackbox) {
      return listing.value.priceToWinBackbox
    }

    return {
      amount: '0',
      currency: currency.value,
    } as MonetaryAmount
  })
}
